import React from "react";

export default function CustomFieldsBooleanDisplayField({ value }) {
  if (value === "true") return "Yes";
  if (value === "false") return "No";
  if (value === "") return "n/a";
  return null;
}
